import React from 'react';

const Footer = () => {
    return (
        <footer className="py-8 bg-white dark:bg-gray-900 border-t border-gray-100 dark:border-gray-800 transition-colors duration-300">
            <div className="container mx-auto px-4 text-center text-gray-500 dark:text-gray-400 text-sm">
                &copy; {new Date().getFullYear()} Project NEXUS / eriver.jp Co.,LTD. All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;
